import * as React from "react";
import Svg, { Path } from "react-native-svg";

function Reverse(props) {
  return (
    <Svg
      width={10}
      height={10}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M5.014 10c-1.347 0-2.593-.5-3.54-1.45-.2-.2-.2-.5 0-.7.199-.2.498-.2.697 0C2.97 8.6 3.966 9 5.014 9c2.194 0 3.989-1.8 3.989-4s-1.795-4-3.99-4c-1.047 0-2.044.4-2.842 1.15-.399.4-1.246 1.4-1.296 1.45-.2.2-.499.25-.698.05-.2-.2-.25-.5-.05-.7.05-.05.898-1.05 1.346-1.45C2.421.5 3.667 0 5.013 0 7.757 0 10 2.25 10 5s-2.244 5-4.986 5z"
        fill="#3D3D3D"
      />
      <Path
        d="M2.52 3.74H.527c-.3 0-.499-.2-.499-.499V1.247c0-.3.2-.5.499-.5.3 0 .499.2.499.5v1.495H2.52c.299 0 .498.2.498.5 0 .298-.2.498-.498.498z"
        fill="#3D3D3D"
      />
    </Svg>
  );
}

export default Reverse;
